<div class="container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="form-group">
            <div class="form-field">
                <label for="agentes">Agente</label>
                <select class="form-control" name="agentes" id="agentes" formControlName="agentes">
                    <option *ngIf="agentesUsuario && agentesUsuario.length > 1" value="TODOS">Todos</option>
                    <option *ngFor="let agente of agentesUsuario" [ngValue]="agente.codigo">{{agente.codigo}} - {{agente.nome}}</option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <div class="form-field">
                <label for="dataInicial">Data Vencimento Inicial</label>
                <input type="date" class="form-control" name="dataInicial" id="dataInicial" formControlName="dataInicial">
            </div>

            <div class="form-field">
                <label for="dataFinal">Data Vencimento Final</label>
                <input type="date" class="form-control" name="dataFinal" id="dataFinal" formControlName="dataFinal">
            </div>
            <input type="submit" class="form-button btn btn-primary mt-4" [disabled]="!form.valid || buscando" [value]="labelButton">
        </div>

    </form>
    <div *ngIf="relatorioCobrancaParcelas && !relatorioCobrancaParcelas.itens && buscaRealizada" class="form-message">Não foram encontrados contratos para os parâmetros escolhidos</div>
    <div *ngIf="relatorioCobrancaParcelas && relatorioCobrancaParcelas.itens">
        <div class="div-message" *ngIf="relatorioCobrancaParcelas">
            <p>Última Atualização: {{relatorioCobrancaParcelas.dataUltimoProcessamento | date:'dd/MM/yyyy'}}</p>
            <p>*Para obter dados do cliente, favor exportar para Excel</p>
        </div>
        <div class="card m-5 p-3">
            <div class="card-body">
                <table class="table table-bordered table-striped table-hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" aria-describedby="Relatorio de Cobrança das Parcelas.">
                    <thead>
                    <tr>
                        <th>Parcela</th>
                        <th>Contrato</th>
                        <th>Data Vencimento</th>
                        <th>Dias Atraso</th>
                        <th>Agente</th>
                        <th>Promotor</th>
                        <th>Valor Parcela</th>
                        <th>Valor Dívida</th>
                        <th>Menor Vencimento Vencida</th>
                        <th>Bloqueio Cobrança</th>
                        <th>Ação Contrária</th>
                        <th>Acordo</th>
                        <th>Parcelas</th>
                        <th style="display:none;">Cliente</th>
                        <th style="display:none;">Telefone</th>
                        <th style="display:none;">Endereço</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of relatorioCobrancaParcelas.itens">
                        <td>{{item.numero}}/{{item.parcelas}}</td>
                        <td>{{item.contrato}}</td>
                        <td>{{item.dataVencimento | date:'dd/MM/yyyy'}}</td>
                        <td>{{item.diasEmAtraso}}</td>
                        <td>{{item.agente}}</td>
                        <td>{{item.nomePromotor}}</td>
                        <td>{{item.valorParcela | currency : 'BRL'}}</td>
                        <td>{{item.valorCorrigido ? item.valorCorrigido : item.valorParcela | currency : 'BRL'}}</td>
                        <td>{{item.menorVencimentoVencida | date:'dd/MM/yyyy'}}</td>
                        <td>{{item.possuiBloqueioCobranca ? 'Sim' : 'Não'}}</td>
                        <td>{{item.possuiAcaoContraria ? 'Sim' : 'Não'}}</td>
                        <td>{{item.possuiAcordo ? 'Sim' : 'Não'}}</td>
                        <td>
                            <table class="box-parcela" aria-describedby="Listagem de Vencimento." aria-hidden="true">
                                <tbody>
                                    <tr>
                                        <td style="padding: 2px;">Vencidas: </td>
                                        <td style="padding: 2px;">{{getParcelas(2,item.listParcelas)}} </td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 2px;">À Vencer: </td>
                                        <td style="padding: 2px;">{{getParcelas(3,item.listParcelas)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td style="display:none;">{{item.nomeCliente}}</td>
                        <td style="display:none;">
                            <table aria-describedby="Listagem de telefone." aria-hidden="true">
                                <tbody>
                                    <tr *ngFor="let telefone of item.telefones">
                                        <td>({{telefone.ddd}}) {{telefone.numero}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td style="display:none;">
                            <table aria-describedby="Listagem de endereços." aria-hidden="true">
                                <tbody>
                                    <tr *ngFor="let endereco of item.enderecos">
                                        <td>{{endereco.logradouro}}, {{endereco.numero}}
                                            {{endereco.complemento}}<br>
                                            {{endereco.bairro}} -
                                            {{endereco.cidade}}/{{endereco.uf}}<br>
                                            {{endereco.cep}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div>
